import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

export const PrivateRoute = (props) => {
  const { component: Component } = props;
  const location = useLocation();
  const nextUrl = `${location.pathname}${location.search}`;

  if (!localStorage.getItem('current_user') || !localStorage.getItem('refresh_token')) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: nextUrl },
        }}
      />
    );
  }

  return <Component {...props} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
};
